import { Observable, of } from 'rxjs'
import { filter, map, withLatestFrom } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { Store } from '@ngrx/store'

import { RolesType } from '../role'
import { roleSelectors } from '../role.selectors'
import { userRoleSelectors } from './user-role.selectors'

@Injectable({
  providedIn: 'root'
})
export class RestrictedToRoleGuard  {
  constructor(private store: Store<AppState>, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const allowedRoles = route.data.roles as RolesType[]

    if (!allowedRoles?.length) {
      return of(true)
    }

    return this.store.select(roleSelectors.selectAll).pipe(
      filter((userRoles) => userRoles.length > 0),
      withLatestFrom(
        this.store.select(userRoleSelectors.selectUserHasRoles, allowedRoles)
      ),
      map(([userRoles, hasRequiredRoles]) => {
        if (!hasRequiredRoles) {
          console.log('User does not have the role to activate the route')
          return this.router.navigateByUrl('/reports')
        }

        return true
      })
    )
  }
}
